module.exports = __webpack_public_path__ + "static/media/image-thursday.3257c876.jpg";